<!-- eslint-disable vue/valid-v-model -->
<template>
  <div id="app">
    <b-modal
      size="xl"
      id="modal-newInstallation"
      ref="modal-newInstallation"
      :title="installation ? 'Modifier installation' : 'Nouvelle installation'"
      hide-footer
    >
      <div class="p-fluid grid mt-3">
        <div class="field col-12 -mt-2">
          <h4>Importer json</h4>
          <!-- <b-form-group label="" label-for="form-image" label-cols-lg="2">
            <b-input-group>
              <b-form-file
                v-model="jsonFile"
                id="form-image"
                :disabled="busy"
                accept=".json"
              ></b-form-file>
            </b-input-group>
          </b-form-group> -->
          <FileUpload
            name="jsonFile[]"
            :showUploadButton="false"
            :showCancelButton="false"
            :customUpload="true"
            @uploader="uploadeFile"
            :auto="true"
            accept=".json"
          >
            <template #empty>
              <p>Glisser/déposer le fichier ici.</p>
            </template>
          </FileUpload>
        </div>

        <div class="field col-12 md:col-4 -mt-2">
          <span class="p-float-label">
            <AutoComplete
              v-model="form.completeLocation"
              :suggestions="filteredCity"
              :field="
                (item) =>
                  item.properties.nom +
                  ' (' +
                  item.properties.codesPostaux[0] +
                  ')'
              "
              @complete="searchCity($event)"
              @item-select="citySelected()"
            >
              <template #item="slotProps">
                <div>
                  {{ slotProps.item.properties.nom }} ({{
                    slotProps.item.properties.codesPostaux[0]
                  }})
                </div>
              </template>
            </AutoComplete>
            <label for="autocomplete"
              ><i class="pi pi-search" /> Commune ou code postal
            </label>
          </span>
          <InlineMessage
            v-if="errors.length && errors.includes('Commune requise')"
            class="mt-1"
            sticky
            :closable="false"
            >Commune requise</InlineMessage
          >
        </div>
        <!-- 
        <b-form-textarea
          v-model="form.completeLocation"
          rows="20"
          cols="30"
        /> -->

        <!-- <b-input v-model="form.city"></b-input>
        <b-input v-model="form.postalCode"></b-input>
        <b-input v-model="form.lat"></b-input>
        <b-input v-model="form.lng"></b-input> -->
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputText id="inputtext-left" v-model="form.city" />
            <label for="inputtext-left">Commune *</label>
          </span>
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputText id="inputtext-left" v-model="form.postalCode" />
            <label for="inputtext-left">Code postal *</label>
          </span>
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputText id="inputtext-left" v-model="form.lat" />
            <label for="inputtext-left">Latitude(format: xx.xxx) *</label>
          </span>
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputText id="inputtext-left" v-model="form.lng" />
            <label for="inputtext-left">Longitude(format:xx.xxx) *</label>
          </span>
        </div>

        <div class="field col-6 md:col-4 -mt-2">
          <SelectButton
            id="selectTypeInstallation"
            v-model="form.installationType"
            :options="['Réseau de chaleur', 'Industrie']"
            class="select_installation_type"
          />
          <InlineMessage
            v-if="
              errors.length && errors.includes('Type d\'installation requis')
            "
            class="mt-1"
            sticky
            :closable="false"
            >Type d'installation requis</InlineMessage
          >
        </div>

        <div class="field col-6 md:col-4 -mt-2">
          <SelectButton
            id="selectIsInUse"
            v-model="isInUse"
            :options="['En service', 'Construction']"
            class="select_installation_type"
          />
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <Dropdown
              v-model="form.capteursType"
              :options="[
                'Plan vitré',
                'Tubes sous vide',
                'A concentation',
                'Autre',
              ]"
            />
            <label for="inputtext-left">Type capteurs *</label>
          </span>
          <InlineMessage
            v-if="errors.length && errors.includes('Type capteurs requis')"
            class="mt-1"
            sticky
            :closable="false"
            >Type capteurs requis</InlineMessage
          >
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputNumber id="inputtext-left" v-model="form.surfaceCapteurs" />
            <label for="inputtext-left">Surface capteurs (m²) *</label>
          </span>
          <InlineMessage
            v-if="errors.length && errors.includes('Surface capteurs requis')"
            class="mt-1"
            sticky
            :closable="false"
            >Surface capteurs requis</InlineMessage
          >
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputNumber id="inputtext" v-model="form.stockage" />
            <label for="inputtext">Stockage (m³) *</label>
          </span>
          <InlineMessage
            v-if="errors.length && errors.includes('Stockage requis')"
            class="mt-1"
            sticky
            :closable="false"
            >Stockage requis</InlineMessage
          >
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputNumber
              v-model="form.commissioningYear"
              :min="1951"
              :max="2499"
            />
            <label for="inputtext">Année de mise service</label>
          </span>
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputNumber id="inputtext-left" v-model="form.power" />
            <label for="inputtext-left">Puissance (kW)</label>
          </span>
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputNumber id="inputtext-left" v-model="form.annualProduction" />
            <label for="inputtext-left">Production annuelle (MWh)</label>
          </span>
        </div>
        <div class="field col-6 md:col-4 -mt-2">
          <span class="p-float-label">
            <InputNumber id="inputtext" v-model="form.annualProductionDate" />
            <label for="inputtext">Année des données de production</label>
          </span>
        </div>

        <div class="field col-6 md:col-8 -mt-2">
          <span class="p-float-label">
            <Textarea v-model="form.infosLinks" autoResize cols="30" />

            <!-- <Chips
              v-model="form.infosLinks"
              v-tooltip.top="{
                value: form.infosLinks
                  ? form.infosLinks.join('\n')
                  : 'Séparer les liens par une virgule ( , ) ou appuyer sur Entrée pour valider.',
              }"
              separator=","
              :max="5"
              :allowDuplicate="false"
              :addOnBlur="true"
            /> -->
            <label for="inputtext-left">Liens</label>
          </span>
        </div>
        <div class="field col-6 md:col-8">
          <span class="p-float-label">
            <Textarea v-model="form.description" rows="2" cols="30" />
            <label for="inputtext-left">Description/remarques</label>
          </span>
        </div>
        <div class="field col-12 ">
          <Galleria
            :value="imgsSrc"
            :activeIndex.sync="activeIndex"
            :responsiveOptions="responsiveOptions"
            :numVisible="7"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="true"
            :showThumbnails="true"
            :visible.sync="visible"
            @change="visible != visible"
          >
            <template #item="slotProps">
              <img
                :src="slotProps.item.src"
                style="width: 100%; display: block;"
              />
            </template>
            <template #thumbnail="slotProps">
              <img
                :src="slotProps.item.src"
                style="width: 20%; display: block;"
              />
            </template>
          </Galleria>

          <div v-if="imgsSrc" class="grid">
            <div v-for="(image, index) of imgsSrc" class="col-3" :key="index">
              <div class="">
                <Button
                  icon="pi pi-times"
                  @click="deleteImg(image)"
                  class="p-button-rounded  delete_button_style"
                />
              </div>
              <img
                :src="image.src"
                style="cursor: pointer; width: 170px"
                @click="imageClick(index, image)"
              />
              <div class="field-radiobutton">
                <RadioButton
                  name="img"
                  :value="image.name"
                  v-model="form.mainPicture"
                />
                <label>Image principale {{ index }}</label>
              </div>
            </div>
            <FileUpload
              mode="advanced"
              name="imgs[]"
              :auto="true"
              :multiple="true"
              accept="image/*"
              :maxFileSize="2000000"
              :customUpload="true"
              @uploader="setUploadedFiles"
            />
          </div>
        </div>
      </div>
      <div>
        <!-- <Message severity="success" v-if="message">
          {{ message }}
        </Message> -->
        <b-alert
          :show="message ? true : false"
          dismissible
          variant="success"
          @dismissed="dismissCountDown === 0"
          @dismiss-count-down="countDownChanged"
        >
          {{ message }}
          <b-progress
            variant="success"
            :max="dismissSecs"
            :value="dismissCountDown"
            height="4px"
          ></b-progress>
        </b-alert>
      </div>
      <div class="text-center">
        <ProgressSpinner v-if="isLoading" />
      </div>
      <div class="float_right">
        <Button
          label="Valider cette installation"
          :disabled="message"
          @click="onSubmit()"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import Button from "primevue/button";
// import Chips from "primevue/chips";
import InputText from "primevue/inputtext";
import AutoComplete from "primevue/autocomplete";
// import Calendar from 'primevue/calendar';
import InputNumber from "primevue/inputnumber";
// import InputMask from 'primevue/inputmask';
import SelectButton from "primevue/selectbutton";
import Dropdown from "primevue/dropdown";
import InlineMessage from "primevue/inlinemessage";
// import Panel from 'primevue/panel';
// import Message from "primevue/message";
import Textarea from "primevue/textarea";
import FileUpload from "primevue/fileupload";
import Galleria from "primevue/galleria";
import RadioButton from "primevue/radiobutton";
import Tooltip from "primevue/tooltip";

import ProgressSpinner from "primevue/progressspinner";

import imageCompression from "browser-image-compression";

// import Slider from 'primevue/slider';

export default {
  // layout: "MainLayout",
  name: "ModalAddInstallation",
  props: {
    installation: Object,
  },
  components: {
    Button,
    InputText,
    AutoComplete,
    Textarea,
    InputNumber,
    // InputMask,
    SelectButton,
    Dropdown,
    InlineMessage,
    // Message,
    FileUpload,
    Galleria,
    RadioButton,
    ProgressSpinner,
    // Chips,
    // Slider
  },
  directives: {
    tooltip: Tooltip,
  },
  data() {
    return {
      isLoading: false,
      network: {},
      busy: null,
      filteredCity: [],
      errors: [],
      display: false,
      jsonFile: null,
      departmentDatas: {},
      form: {},
      message: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      isInUse: null,
      imgsSrc: [],
      activeIndex: 0,
      visible: false,
      newFiles: [],
      imgToDelete: [],
      responsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 5,
        },
        {
          breakpoint: "768px",
          numVisible: 3,
        },
        {
          breakpoint: "560px",
          numVisible: 1,
        },
      ],
    };
  },
  async fetch() {},
  watch: {
    isInUse: {
      handler(value) {
        if (value === "En service") {
          this.form.inUse = true;
        } else {
          this.form.inUse = false;
        }
        if (value === "Construction") {
          this.form.inConstruction = true;
        } else {
          this.form.inConstruction = false;
        }
      },
    },
    network: {
      handler(newValue) {
        this.checkForm(newValue);
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    if (this.installation) {
      this.form = this.installation;

      this.imgsSrc = this.form.imgs.map((item) => ({
        src: process.env.VUE_APP_API_BASE_URL + "/" + item,
        name: item,
      }));
    }
  },
  async mounted() {
    if (this.form.inUse === true) {
      this.isInUse = "En service";
    }

    if (this.form.inConstruction === true) {
      this.isInUse = "Construction";
    }
  },
  filters: {
    splitArray(value) {
      if (!value) return "";

      return value.join("\n");
    },
  },
  // fetchOnServer: false,
  methods: {
    deleteImg(image) {
      this.imgsSrc = this.imgsSrc.filter((item) => item.name !== image.name);
      this.newFiles = this.newFiles.filter((item) => item.name !== image.name);

      if (this.form.imgs.includes(image.name)) {
        this.form.imgs = this.form.imgs.filter((item) => item !== image.name);
        this.imgToDelete.push(image.name);
      }
    },
    setUploadedFiles(event) {
      // console.log(event);
      const files = event.files;
      for (const file of files) {
        // const renamedFile = new File(
        //   [file],
        //   Date.now() + "." + file.type.split("/")[1],
        //   {
        //     type: file.type,
        //   }
        // );
        // const newFiles = [renamedFile];
        const url = URL.createObjectURL(file);
        this.imgsSrc.push({
          name: file.lastModified + "." + file.type.split("/")[1],
          src: url,
        });
        this.newFiles.push(file);
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    imageClick(index) {
      // console.log(index);
      this.activeIndex = index;
      this.visible = !this.visible;
    },
    uploadeFile(event) {
      const value = event.files[0];
      const fileReader = new FileReader();

      fileReader.onload = (e) => {
        const result = JSON.parse(e.target.result);

        this.form = result;

        this.form.city = this.form.completeLocation.properties.nom;
        this.form.postalCode = this.form.completeLocation.properties.codesPostaux[0];
        this.form.lat = this.form.completeLocation.geometry.coordinates[1];
        this.form.lng = this.form.completeLocation.geometry.coordinates[0];

        if (this.form.installationType === "Procédé industriel") {
          this.$set(this.form, "installationType", "Industrie");
        }
        
        if (this.form.installationType === "Réseau de chaleur") {
          this.$set(this.form, "installationType", "Réseau");
        }

        if (this.form.inUse === true) {
          this.isInUse = "En service";
        }

        if (this.form.inConstruction === true) {
          this.isInUse = "Construction";
        }

        this.imgsSrc = this.form.imgs.map((item) => ({
          src: process.env.VUE_APP_API_BASE_URL + "/" + item,
          name: item,
        }));

        this.$set(this.form, "mainPicture", this.imgsSrc[0]?.name);

        this.form.infosLinks = this.form.infosLinks?.join("\n");
      };
      fileReader.readAsText(value);
    },
    checkForm() {
      this.errors = [];

      if (!this.form.stockage) {
        this.errors.push("Stockage requis");
      }
      if (!this.form.surfaceCapteurs) {
        this.errors.push("Surface capteurs requis");
      }
      if (!this.form.capteursType) {
        this.errors.push("Type capteurs requis");
      }
      if (!this.form.installationType) {
        this.errors.push("Type d'installation requis");
      }
      if (!this.form.completeLocation) {
        this.errors.push("Commune requise");
      }

      if (!this.form.requesterName) {
        this.errors.push("Nom requis");
      }
      if (!this.form.requesterMail && !this.form.requesterPhone) {
        this.errors.push("Email ou téléphone requis");
      } else if (
        this.form.requesterMail &&
        !this.validEmail(this.form.requesterMail)
      ) {
        this.errors.push("Email non valide");
      }

      // e.preventDefault();
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    async searchCity(event) {
      let res;
      if (!Number.isNaN(+event.query)) {
        if (event.query.length <= 2) {
          const resp = await fetch(
            `https://geo.api.gouv.fr/communes?codeDepartement=${event.query}&format=geojson&boost=population&limit=5`
          );
          res = await resp.json();
        } else {
          const resp = await fetch(
            `https://geo.api.gouv.fr/communes?codePostal=${event.query}&format=geojson&boost=population&limit=5`
          );
          res = await resp.json();
        }
      } else {
        const resp = await fetch(
          `https://geo.api.gouv.fr/communes?nom=${event.query}&format=geojson&boost=population&limit=5`
        );
        res = await resp.json();
      }

      this.filteredCity = res.features;
    },
    citySelected() {
      this.form.city = this.form.completeLocation.properties.nom;
      this.form.postalCode = this.form.completeLocation.properties.codesPostaux[0];
      this.form.lat = this.form.completeLocation.geometry.coordinates[1];
      this.form.lng = this.form.completeLocation.geometry.coordinates[0];
    },
    async onSubmit() {
      this.dismissCountDown = this.dismissSecs;

      if (this.imgToDelete.length) {
        for (const imageName of this.imgToDelete) {
          try {
            fetch(
              `${process.env.VUE_APP_API_BASE_URL}/api/v1/installation/deleteImg`,
              {
                method: "POST",
                body: JSON.stringify({ name: imageName }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.localStorage.token}`
                },
              }
            );
          } catch (error) {
            console.log(error);
          }
        }
      }

      if (this.newFiles.length) {
        const rest = this.uploadFiles(this.newFiles);
        this.newFiles = rest;
        this.form.imgs = this.imgsSrc.map((item) => item.name);
      }
      let res;
      if (this.installation) {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/installation/updateInstallation`,
          {
            method: "POST",
            body: JSON.stringify(this.form),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      } else {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/installation/saveInstallation`,
          {
            method: "POST",
            body: JSON.stringify(this.form),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      }

      const json = await res.json();

      if (json.message) {
        this.message = json.message;

        setTimeout(() => {
          this.message = null;
          // this.form = {};
        }, 5000);
      }
    },
    async uploadFiles(files) {
      const filesArr = files;
      this.isLoading = true;
      const options = {
        // maxSizeMB: 1, // number(default: Number.POSITIVE_INFINITY)
        // maxWidthOrHeight, // number compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
        // but, automatically reduce the size to smaller than the maximum Canvas size supported by each browser.
        // Please check the Caveat part for details.
        // onProgress: Function, // optional, a function takes one progress argument (percentage from 0 to 100)
        // useWebWorker: boolean, // optional, use multi-thread web worker, fallback to run in main-thread (default: true)

        // following options are for advanced users
        // maxIteration: number, // optional, max number of iteration to compress the image (default: 10)
        // exifOrientation: number, // optional, see https://stackoverflow.com/a/32490603/10395024
        // fileType: string, // optional, fileType override
        initialQuality: 0.5, // optional, initial quality value between 0 and 1 (default: 1)
      };

      const promises = files.map(async (file) => {
        // const fileName = Date.now();
        // console.log(fileName);
        // const myRenamedFile = new File([file], fileName, {
        //   type: file.type,
        //   lastModified: fileName,
        // });
        // if (file.type.includes("image")) {
        file = await imageCompression(file, options);
        // console.log(file.size);
        // } else {
        //   return;
        // }
        // console.log(file);
        // const imgName = file.name;
        const formData = new FormData();
        formData.append(file.lastModified, file);

        // formData.append(imgName.split(".")[0], file);
        // formData.set('questionId', questionId);

        return new Promise((resolve) => {
          fetch(
            process.env.VUE_APP_API_BASE_URL +
              "/api/v1/installation/uploadWJwt",
            {
              method: "POST",
              // body: JSON.stringify({
              //   apiKey: 'a^QT%5cCyhp7EM@7fdx$gd4QqJTrnYkTK9yWtcD3UZ@',
              //   recaptchaToken: token,
              // }),
              headers: {
                Authorization: `Bearer ${this.localStorage.token}`
              },
              body: formData,
            }
          )
            .then(() => {
              filesArr.filter((item) => item.name !== file.name);
              resolve();
            })
            .catch((error) => console.log(error));
        });
      });
      await Promise.all(promises);
      this.isLoading = false;
      return filesArr;
    },
  },
};
</script>
<style>
@import "https://unpkg.com/primeflex@3.1.2/primeflex.css";
</style>

<style>
.float_left {
  float: left;
}
.float_right {
  float: right;
}
.select_installation_type {
  height: 48px;
}
.p-inline-message-text {
  font-size: 0.9rem !important;
}
.p-inline-message {
  height: 20px;
  margin-bottom: 10px;
}
.p-panel-header {
  color: red !important;
}
.p-inline-message-icon {
  display: none;
}

.p-button.delete_button_style {
  position: absolute;
  width: 31px !important;
  height: 31px !important;
  background: transparent !important;
  color: #000;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%) !important;
  border: 1px solid #d32f2f;
}

.p-button.delete_button_style:hover {
  background: #d32f2f !important;
  /* color: #fff; */
}

.p-chips-token-label {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8rem;
}

.p-tooltip .p-tooltip-text {
  width: 50vw !important;
}

.p-tooltip {
  z-index: 1055;
}
</style>
